import React from 'react';
import styled from 'styled-components';
import { Container, Media } from '../../components';
import { OpenRolesDesktop } from './desktop';
import { OpenRolesMobile } from './mobile';
import { OpenRolesTablet } from './tablet';

const DesktopWrapper = styled.div`
  background-color: #ffffff;
`;

export const OpenRoles = React.forwardRef<any>((props, ref) => {
  return (
    <section ref={ref}>
      <Container>
        <Media at="sm">
          <OpenRolesMobile />
        </Media>
      </Container>
      <Container>
        <Media at="md">
          <OpenRolesTablet />
        </Media>
      </Container>
      <DesktopWrapper>
        <Container>
          <Media greaterThanOrEqual="xmd">
            <OpenRolesDesktop />
          </Media>
        </Container>
      </DesktopWrapper>
    </section>
  );
});
